































































































































































































































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { Volunteer } from '@/data/models/volunteer.model';
import { CrudService } from '@/data/services/crud.service';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Veicolo } from '@/data/models/veicolo.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import  Note  from '../attori/note/Note.vue';
import { currencyToNumber, numberMask } from '@/data/utils/helper';

@Component({
	components: {
		ValidationProvider,
		ValidationObserver,
		Note
	}
})
export default class VolontarioDetail extends Vue{
	@Inject('CrudService') volonteerCrudService!: CrudService<Volunteer>;
	@Inject('CrudService') vehicleCrudService!: CrudService<Veicolo>;
	@Prop() volunteerid!: number;
	@Prop() actorid!: number;
	volunteer!: Volunteer;
	vehicle!: Veicolo;
	vehicleClass: ClassType<Veicolo> = Veicolo;
	enableEntity: boolean = false;

	numberMask: any = numberMask();

	currencies: any = {};

	constructor() {
		super();
		this.init();
	}

	init() {
		this.volunteer = new Volunteer();
		this.vehicle = new Veicolo();
	}

	@Watch('volunteerid') 
	onActorChange() {
		if(this.volunteerid) {
			this.loadVolunteer();
		}
	}

	loadVolunteer() {
		this.volonteerCrudService.getEntity(Volunteer, 'volunteer', this.volunteerid).then((result: any) => {
			if(result.id) {
				this.volunteer = result;
				this.vehicle = this.volunteer.vehicle;
				this.enableEntity = true;
			}
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	onVehicleChange() {
		if (this.vehicle) {
			this.volunteer.vehicleid = this.vehicle.id;
		}
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	onEnableEntityChange(event: any) {
		if(!event && this.volunteer.id) {
			this.$buefy.dialog.confirm({
				message: this.$t('warning-volunteer-delete') as string,
				type: 'is-danger',
				hasIcon: true,
				cancelText: this.$t('annulla') as string,
				onConfirm: () => {
					this.volonteerCrudService
						.deleteEntity(Volunteer, 'volunteer', this.volunteer)
						.then(() => {
							this.init();
							this.$emit('updateVolunteer', this.volunteer);
							this.$buefy.notification.open({
								message: '' + this.$t('volunteer-deleted'),
								type: 'is-success',
							});
						})
						.catch((error) => {
							this.$buefy.notification.open({
								message: error.msg,
								type: 'is-danger',
							});
						});
				}, 
				onCancel: () => {
					this.enableEntity = true;
				}
			});
		}
	}

	submit() {
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.volunteer, k, this.currencies[k]);
		});
		const call = (this.volunteer!.id) ? 
			this.volonteerCrudService.saveEntity(Volunteer, 'volunteer', this.volunteer) : 
			this.volonteerCrudService.createEntity(Volunteer, 'volunteer', this.volunteer);
		call.then(result => {
			this.volunteer = result;
			this.$emit('updateVolunteer', this.volunteer);
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

}
